module.exports = __webpack_public_path__ + "img/card_v.887eec74.png";